import { render } from "./tw-button.vue?vue&type=template&id=655bccbd"
import script from "./tw-button.vue?vue&type=script&lang=js"
export * from "./tw-button.vue?vue&type=script&lang=js"
script.render = render

export default script